export class CardLinkDto {

    title: string;
    distance: string;
    /* minPrice: number;
    maxPrice: number;
    currency: string; */
    details: string;
    fullAddress: string;
    cardLink: {
        link: string;
        recommended: boolean;
    };

    constructor(title: string, 
        distance: string, /* minPrice: number, maxPrice: number, currency: string  */
        link: string, 
        recommended: boolean, 
        details: string,
        fullAddress: string) {
        this.fullAddress = fullAddress;
        this.title = title;
        this.distance = distance;
        this.details = details;
        /* this.minPrice = minPrice;
        this.maxPrice = maxPrice;
        this.currency = currency; */
        this.cardLink = { link, recommended };
    }

}